import React from 'react';

import Icon from '3-components/Icon/Icon';

interface FormElementWrapperProps {
    elementValidationState?: string,
    isDisabled?: boolean,
    elementSize?: string,
    elementCustomClass?: string,
    elementId: string,
    elementLabel?: string,
    notRequired?: boolean,
    prefixIcon?: string,
    suffixIcon?: string,
    children?: React.ReactNode,
    elementValidationMessage?: string
}

const FormElementWrapper = (props: FormElementWrapperProps) => {
    const {
        elementValidationState,
        isDisabled,
        elementSize,
        elementCustomClass,
        elementId,
        elementLabel,
        notRequired,
        prefixIcon,
        suffixIcon,
        children,
        elementValidationMessage
    } = props;

    const buildElementClassname = () => {
        const validationClass = elementValidationState ? `validation-${elementValidationState}` : '';
        const disabledClass = isDisabled ? 'is-disabled' : '';
        const sizeClass = `element-size-${elementSize ? elementSize : 'md'}`;

        return `form-element ${validationClass} ${disabledClass} ${elementCustomClass ? elementCustomClass : ''} ${sizeClass}`;
    };
    return (
        <div className={buildElementClassname()}>
            <label htmlFor={elementId} className={elementLabel ? '' : ' sr-only'}>
                {elementLabel ? elementLabel : elementId}
                {notRequired ? (<span className="form-optional">(optional)</span>) : null}
            </label>
            <div className={`element-wrapper ${prefixIcon ? ' has-prefix-icon' : ''}${suffixIcon ? ' has-suffix-icon' : ''}`}>
                {prefixIcon && (
                    <Icon icon={prefixIcon} className="prefix-icon" />
                )}
                {/* {children && { children }} */}
                {children}
                {suffixIcon && (
                    <Icon icon={suffixIcon} className="suffix-icon" />
                )}
            </div>
            {elementValidationMessage && (
                <div className="validation-message"><span className="validation-message-icon" />{{ elementValidationMessage }}</div>
            )}
        </div>
    );
};

export default FormElementWrapper;
